module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tip":"Расскажите, что вы пытались сделать и что произошло.","send":"Отправить","successMessage":"Ваше сообщение отправлено в техподдержку"}}')
  delete Component.options._Ctor
}
